/**
 * @overview 推荐查看
 * @author jzhu
 * @date 2020-9-26
 */

import React from 'react'
import {connect} from 'dva'
import {modelUtils} from '@/utils'
import {framework_tool, component_tool, utils_tool} from '@/tool'

let {WizContainer, ossFileUtils} = framework_tool
let {WizCard, WizSpin, WizDescriptions} = component_tool
let {Session} = utils_tool
import {AudienceGroupItem} from '@/components';

const getParamRecord = (history) => {
  let record = {}
  if (history.location && history.location.pathname === '/featured/management/featuredLook') {
    if (history.location.record) {
      record = history.location.record
      Session.set('featuredLook', record)
    } else {
      record = Session.get('featuredLook') || {}
    }
  }
  return record
}

const platforms = {
  'PC': 0,
  'APP': 1,
}

const positions = {
  '首页轮播': 0,
  '广告位': 1,
  '路径推荐位': 2,
  '任务推荐位': 3
}

class FeaturedLook extends WizContainer {

  componentName = 'FeaturedLook'

  constructor(props) {
    super(props)
    let {history} = props
    let record = getParamRecord(history)
    this.state = {
      id: record.id
    }
  }

  _componentDidMount = () => {
    this.doAction({
      path: 'featured/find',
      payload: {
        key: 'featuredLook',
        apiParams: {id: this.state.id}
      }
    })
  }

  _dict = (data) => {
    let dict = []
    for (let [key, value] of Object.entries(data)) {
      let item = {code: value, codeName: key}
      dict.push(item)
    }
    return dict
  }

  _columns = () => {
    let platformDict = this._dict(platforms)
    let positionDict = this._dict(positions)
    return [
      {
        title: '关联内容',
        name: 'entityName',
        dataIndex: 'entityName',
        describeItem: {
          render: (text, record) => {
            let path
            switch (record.entityType) {
              case 0:

                break
              case 1:
                path = '/featured/management/featuredLook/featuredExam'
                break
              case 2:
                path = '/featured/management/featuredLook/featuredSurvey'
                break
              case 3:

                break
              case 4:
                path = '/featured/management/featuredLook/featuredTopic'
                break
              case 5:
                path = '/featured/management/featuredLook/featuredActivity'
                break
              case 6:

                break
              case 12:
                path = '/featured/management/featuredLook/featuredTrainPath'
                break
              default:
                break
            }
            let click = () => path && this.jumpPage('push', path, {id: record.entityId, name: record.entityName})
            return <a title={record.entityName} onClick={click}>{record.entityName}</a>
          }
        }
      },
      {
        title: '关联类型',
        name: 'entityType',
        dataIndex: 'entityType',
        dict: [
          {code: 0, codeName: '课程'},
          {code: 1, codeName: '考试'},
          {code: 2, codeName: '问卷'},
          // { code: 3, codeName: '直播' },
          {code: 15, codeName: '报名'},
          {code: 20, codeName: '公告'},
          // {code: 22, codeName: '话题'},
          // {code: 23, codeName: '活动'},
          {code: 25, codeName: '系列化课程'},
          {code: 26, codeName: '直播'},
          {code: 12, codeName: '培训路径'},
          {code: 59, codeName: '练习'},
          // { code: 37, codeName: '投票' }
        ],
        describeItem: {}
      },
      {
        title: '发布平台',
        name: 'platforms',
        dataIndex: 'platforms',
        dict: platformDict,
        describeItem: {
          type: 'checkbox'
        }
      },
      {
        title: '推荐位',
        name: 'positions',
        dataIndex: 'positions',
        dict: positionDict,
        describeItem: {
          type: 'checkbox'
        }
      },
      {
        title: '生效时间',
        name: 'startDate',
        dataIndex: 'startDate',
        describeItem: {}
      },
      {
        title: '失效时间',
        name: 'endDate',
        dataIndex: 'endDate',
        describeItem: {}
      },
      {
        title: 'PC、APP轮播图',
        name: 'carouselImg',
        dataIndex: 'carouselImg',
        describeItem: {
          render: (text, {carouselImg}) => {
            return checkEmpty(carouselImg) ?
              <img height={334 / 3} width={645 / 3} src={getOssFilePath(carouselImg)}/> : <></>
          }
        }
      },
      // {
      //   title: '企业微信轮播图',
      //   name: 'busWxImg',
      //   dataIndex: 'busWxImg',
      //   describeItem: {
      //     render: (text, {busWxImg}) => {
      //       return checkEmpty(busWxImg) ?
      //         <img height={334 / 3} width={645 / 3} src={getOssFilePath(busWxImg)}/> : <></>
      //     }
      //   }
      // },
      {
        title: 'PC广告图',
        name: 'advertisingImg',
        dataIndex: 'advertisingImg',
        describeItem: {
          render: (text, {advertisingImg}) => {
            return checkEmpty(advertisingImg) ?
              <img height={170 / 3} width={1160 / 3} src={getOssFilePath(advertisingImg)}/> : <></>
          }
        }
      },
      // {
      //   title: 'APP广告图',
      //   name: 'advertisingAppImg',
      //   dataIndex: 'advertisingAppImg',
      //   describeItem: {
      //     render: (text, {advertisingAppImg}) => {
      //       return checkEmpty(advertisingAppImg) ?
      //         <img height={136 / 3} width={464 / 3} src={getOssFilePath(advertisingAppImg)}/> : <></>
      //     }
      //   }
      // },
      {
        title: '路径推荐图',
        name: 'pathImg',
        dataIndex: 'pathImg',
        describeItem: {
          render: (text, {pathImg}) => {
            return checkEmpty(pathImg) ? <img height={207 / 3} width={400 / 3} src={getOssFilePath(pathImg)}/> : <></>
          }
        }
      },
      {
        title: '任务推荐图',
        name: 'taskImg',
        dataIndex: 'taskImg',
        describeItem: {
          render: (text, {taskImg}) => {
            return checkEmpty(taskImg) ? <img height={207 / 3} width={400 / 3} src={getOssFilePath(taskImg)}/> : <></>
          }
        }
      },
      {
        title: '推荐范围',
        name: 'authInfo',
        dataIndex: 'authInfo',
        describeItem: {
          render: (text, record) => {
            let initialValue = {
              groupId: null,
              isAll: null,
              orgIds: [],
              positionIds: [],
              positionCategoryIds: [],
              personIds: [],
              message: []
            }
            initialValue = record.authInfo
            return (
              <AudienceGroupItem {...initialValue} />
            )
          }
        }
      },
      {
        title: '推荐状态',
        name: 'state',
        dataIndex: 'state',
        dict: [
          {code: 0, codeName: '草稿'},
          {code: 1, codeName: '打开'},
          {code: 2, codeName: '关闭'},
          {code: 3, codeName: '失效'}
        ],
        describeItem: {}
      },
      {
        title: '更新时间',
        name: 'updateTime',
        dataIndex: 'updateTime',
        describeItem: {}
      }
    ]
  }

  _render() {
    let {featuredLook, featuredLoading} = this.props
    let wizDescriptionsProps = {
      record: featuredLook.data || {},
      columns: this._columns(),
      column: 1,
      bordered: true
    }
    return (
      <WizCard>
        <WizSpin tip={'加载中'} spinning={featuredLoading}>
          <WizDescriptions {...wizDescriptionsProps} />
        </WizSpin>
      </WizCard>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  let {featured} = state
  let featuredLook = modelUtils.getModelEntity(featured, 'featuredLook')
  const load = modelUtils.getLoadingState(state, 'featured')
  return {
    featuredLook,
    ...load
  }
}

export default connect(mapStateToProps)(FeaturedLook)
